import {GenericUsefulLinksMenuItemRenderer} from "../generic-useful-links-menu-item-renderer";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {IMenuItemConfigReader} from "../../../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {NullableUndefinedString} from "../../../../../../common/types/nullable-types";

export default class TouchIdMenuItemRenderer extends GenericUsefulLinksMenuItemRenderer {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("touchIdMenuItem", configReader, services);

        makeObservable(this);

        this.services.sdk.events.onTouchIDActiveStateChanged(() => this._updateTouchIdStatus());

        if(this.services.device.hybrid.inCasino) {
            this._updateTouchIdStatus();
        }
    }

    private async _updateTouchIdStatus(): Promise<void> {


        try {
            const isEnabled = await this.services.hybrid.isDeviceTouchEnable();

            runInAction(() => {
                this._enabled = Boolean(isEnabled);
            });

            if(isEnabled) {
                const isFeatureOn = await this.services.hybrid.getTouchIDFeaturer().getTokenAndCheckEnable();
                runInAction(() => {
                    if(Boolean(isFeatureOn)) {
                        this._extraText = 'On';
                    } else {
                        this._extraText = 'Off';
                    }
                });
            }
        } catch (err) {
            this.services.logger.error('Failed to check touch ID feature', err);
        }


    }

    @observable.ref
    private _enabled: boolean = false;

    @observable.ref
    private _extraText: NullableUndefinedString = null;

    get sideText(): NullableUndefinedString {
        return this._extraText;

    }

    protected _shouldDisplay(): boolean {
        return this._enabled && super._shouldDisplay() && this.services.device.hybrid.inCasino;
    }
}